<template>
  <div id="app">
    <navbar />

    <section class="main-content">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <Suspense>
              <router-view />
            </Suspense>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Navbar from "./components/Navbar";
export default {
  components: { Navbar },
};
</script>
